module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), _c('legend', {
    staticStyle: {
      "background-color": "#fcfcfc"
    }
  }, [_vm._v("\n         Licenciamento Ambiental\n   ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group box-body"
  }, [_c('div', {
    staticClass: "column start-centered"
  }, [_c('label', {
    staticClass: "control-label f-required label-head"
  }, [_vm._v("1 - As atividades propostas para o projeto são passíveis de licenciamento ambiental obrigatório?")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start indicativo-container"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indicativo),
      expression: "indicativo"
    }],
    attrs: {
      "type": "radio",
      "value": "Sim"
    },
    domProps: {
      "checked": _vm._q(_vm.indicativo, "Sim")
    },
    on: {
      "change": function($event) {
        _vm.indicativo = "Sim"
      }
    }
  }), _vm._v(" Sim\n           "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indicativo),
      expression: "indicativo"
    }],
    attrs: {
      "type": "radio",
      "value": "Não"
    },
    domProps: {
      "checked": _vm._q(_vm.indicativo, "Não")
    },
    on: {
      "input": function($event) {
        return _vm.changeIndicativo()
      },
      "change": function($event) {
        _vm.indicativo = "Não"
      }
    }
  }), _vm._v(" Não\n           "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.indicativo === 'Não') ? _c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justificativaIndicativo),
      expression: "justificativaIndicativo"
    }],
    staticClass: "form-control col",
    attrs: {
      "placeholder": "Justificativa da Seleção",
      "type": "text"
    },
    domProps: {
      "value": (_vm.justificativaIndicativo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.justificativaIndicativo = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.indicativo === 'Sim') ? _c('div', {
    staticClass: "w-100 column start-centered gap-10"
  }, [(!_vm.editarLicencaInformativa) ? _c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Selecione:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaInformativa.licenca),
      expression: "licencaInformativa.licenca"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tipo de Ação",
      "disabled": !_vm._.isEmpty(_vm.tableInformativa.items) && !_vm.cadastroProposta,
      "placeholder": "Selecione",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.licencaInformativa, "licenca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeLicencaInformativa()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposInformativa), function(tipo) {
    return _c('option', {
      domProps: {
        "value": tipo.licenca
      }
    }, [_vm._v(_vm._s(tipo.licenca))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.licencaInformativa.licenca === 'Licença' && !_vm.editarLicencaInformativa) ? _c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Selecione o Tipo de Licença:")]) : _vm._e(), _vm._v(" "), (_vm.licencaInformativa.licenca === 'Licença' && !_vm.editarLicencaInformativa) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaInformativa.licencaSelecao),
      expression: "licencaInformativa.licencaSelecao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tipo de Ação",
      "placeholder": "Selecione",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.licencaInformativa, "licencaSelecao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeLicencaInformativaSelecao()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposSelecaoInformativa), function(tipo) {
    return _c('option', {
      domProps: {
        "value": tipo.licenca
      }
    }, [_vm._v(_vm._s(tipo.licenca))])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Obrigatório durante o prazo de execução do projeto', 'Licença', ''], _vm.licencaInformativa.licenca) && !_vm.editarLicencaInformativa && _vm._.isEmpty(_vm.tableInformativa.items)) ? _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleInformativo(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                 " + _vm._s(_vm.textoAnexoInformativo) + "\n             ")])], 1) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Obrigatório durante o prazo de execução do projeto', 'Licença', ''], _vm.licencaInformativa.licenca) && !_vm.editarLicencaInformativa && _vm.cadastroProposta) ? _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleInformativo(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                 " + _vm._s(_vm.textoAnexoInformativo) + "\n             ")])], 1) : _vm._e(), _vm._v(" "), (_vm._.includes(['Licença'], _vm.licencaInformativa.licenca) && (!_vm._.includes(['Prévia (LP)', 'Instalação (LI)', 'Licença de Alteração (LA)', ''], _vm.licencaInformativa.licencaSelecao)) && !_vm.editarLicencaInformativa && !_vm.cadastroProposta && _vm._.isEmpty(_vm.tableInformativa.items)) ? _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleInformativo(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                 " + _vm._s(_vm.textoAnexoInformativo) + "\n             ")])], 1) : _vm._e(), _vm._v(" "), (_vm._.includes(['Licença'], _vm.licencaInformativa.licenca) && (!_vm._.includes(['Prévia (LP)', 'Instalação (LI)', 'Licença de Alteração (LA)', ''], _vm.licencaInformativa.licencaSelecao)) && !_vm.editarLicencaInformativa && _vm.cadastroProposta && _vm._.isEmpty(_vm.tableInformativa.items)) ? _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleInformativo(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                 " + _vm._s(_vm.textoAnexoInformativo) + "\n             ")])], 1) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Obrigatório durante o prazo de execução do projeto', ''], _vm.licencaInformativa.licenca) && !_vm.editarLicencaInformativa) ? _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Documento cadastrado:")]), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.tableInformativa.bordered,
      "items": _vm.tableInformativa.items,
      "hover": _vm.tableInformativa.hover,
      "fields": _vm.tableInformativa.fields,
      "filter": _vm.tableInformativa.filter,
      "current-page": _vm.tableInformativa.currentPage,
      "per-page": _vm.tableInformativa.perPage,
      "sort-by": _vm.tableInformativa.sortBy,
      "sort-desc": _vm.tableInformativa.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableInformativa, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableInformativa, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableInformativa, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableInformativa, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "edita-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              return _vm.toggleInformativo(true, true)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "exclui-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.confirmaExclusao('Confirma Exclusão?', function () { return _vm.excluiInformativa(row.item); })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    }, {
      key: "validade",
      fn: function(row) {
        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
          staticClass: "badge badge-danger",
          attrs: {
            "title": "Vencida"
          }
        }, [_vm._v("\n                 Vencida em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : (row.value) ? _c('span', {
          staticClass: "badge badge-success",
          attrs: {
            "title": "Dentro da validade"
          }
        }, [_vm._v("\n                 " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : _vm._e()]
      }
    }, {
      key: "inclusao",
      fn: function(row) {
        return [_vm._v("\n                 " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]
      }
    }, {
      key: "anexo",
      fn: function(row) {
        return [_c('a', {
          staticClass: "ng-binding",
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onDownload(row.value[0])
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.value[0].ds_nome_arquivo))])]
      }
    }], null, false, 2781322628)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaInformativa) ? _c('div', {
    staticClass: "column start-centered edicao-container"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Anexo:")]), _vm._v(" "), _c('uploadLicencas', {
    staticClass: "w-100",
    attrs: {
      "propDocumentos": _vm.licencaInformativa.anexo,
      "localUso": "LICENCIAMENTO_AMBIENTAL",
      "maxFiles": 1
    }
  }), _vm._v(" "), (_vm.licencaInformativa.licenca === 'Isento com base em legislação estadual/municipal') ? _c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data da Vigência:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.licencaInformativa.validade),
      callback: function($$v) {
        _vm.$set(_vm.licencaInformativa, "validade", $$v)
      },
      expression: "licencaInformativa.validade"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Embasamento Legal:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaInformativa.observacoes),
      expression: "licencaInformativa.observacoes"
    }],
    staticClass: "form-control col",
    attrs: {
      "placeholder": "Embasamento da legislação local",
      "type": "text"
    },
    domProps: {
      "value": (_vm.licencaInformativa.observacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.licencaInformativa, "observacoes", $event.target.value)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.licencaInformativa.licenca === 'Dispensa com base na legislação estadual/municipal') ? _c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Vigência da Dispensa:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.licencaInformativa.validade),
      callback: function($$v) {
        _vm.$set(_vm.licencaInformativa, "validade", $$v)
      },
      expression: "licencaInformativa.validade"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.licencaInformativa.licenca === 'Licença') ? _c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de Vigência:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.licencaInformativa.validade),
      callback: function($$v) {
        _vm.$set(_vm.licencaInformativa, "validade", $$v)
      },
      expression: "licencaInformativa.validade"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaInformativa) ? _c('div', {
    staticClass: "row-flex centered-end w-100 sessao-salvar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleInformativo(false, true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.adicionaInformativa()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Salvar ")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.mostrarDemaisLicencas && !_vm.telaProjeto) ? _c('legend', {
    staticStyle: {
      "background-color": "#fcfcfc"
    }
  }, [_vm._v("\n     Procedimentos\n   ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas && !_vm.telaProjeto) ? _c('label', {
    staticClass: "control-label f-required label-head"
  }, [_vm._v("2 - Procedimento(s) de Licença(s) Ambiental(is) apresentada(s) na fase de análise (se houver condicionante de publicação para validade, esta comprovação deve ser anexada conjuntamente):")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas && !_vm.telaProjeto) ? _c('div', {
    staticClass: "column all-centered w-100 gap-10"
  }, [(!_vm.editarLicencaProcedimentos) ? _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleProcedimento(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n           Adicionar Procedimento \n         ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editarLicencaProcedimentos) ? _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.tableProcedimento.bordered,
      "items": _vm.tableProcedimento.items,
      "hover": _vm.tableProcedimento.hover,
      "fields": _vm.tableProcedimento.fields,
      "filter": _vm.tableProcedimento.filter,
      "current-page": _vm.tableProcedimento.currentPage,
      "per-page": _vm.tableProcedimento.perPage,
      "sort-by": _vm.tableProcedimento.sortBy,
      "sort-desc": _vm.tableProcedimento.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableProcedimento, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableProcedimento, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableProcedimento, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableProcedimento, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "edita-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              return _vm.editaProcedimento(row.item, row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "exclui-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.confirmaExclusao('Confirma Exclusão?', function () { return _vm.excluiProcedimento(row.item); })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    }, {
      key: "validade",
      fn: function(row) {
        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
          staticClass: "badge badge-danger",
          attrs: {
            "title": "Vencida"
          }
        }, [_vm._v("\n                 Vencida em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : (row.value) ? _c('span', {
          staticClass: "badge badge-success",
          attrs: {
            "title": "Dentro da validade"
          }
        }, [_vm._v("\n                 " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : _vm._e()]
      }
    }, {
      key: "anexo",
      fn: function(row) {
        return [_c('a', {
          staticClass: "ng-binding",
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onDownload(row.value[0])
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.value[0].ds_nome_arquivo))])]
      }
    }], null, false, 3601985519)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaProcedimentos) ? _c('div', {
    staticClass: "column start-centered edicao-container"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cadastro de procedimento ")]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("2 - Selecione o Procedimento: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplateProcedimento.licenca),
      expression: "licencaTemplateProcedimento.licenca"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tipo de Ação",
      "placeholder": "Selecione",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.licencaTemplateProcedimento, "licenca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposProcedimento), function(tipo) {
    return _c('option', {
      domProps: {
        "value": tipo.licenca
      }
    }, [_vm._v(_vm._s(tipo.licenca))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Tipo de Procedimento: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplateProcedimento.tipo_procedimento),
      expression: "licencaTemplateProcedimento.tipo_procedimento"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tipo de Ação",
      "placeholder": "Selecione",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.licencaTemplateProcedimento, "tipo_procedimento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Monitoramento e Alteração"
    }
  }, [_vm._v("Monitoramento e Alteração")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Tipo de Licença"
    }
  }, [_vm._v("Tipo de Licença")])])]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Anexo:")]), _vm._v(" "), _c('uploadLicencas', {
    staticClass: "w-100",
    attrs: {
      "propDocumentos": _vm.licencaTemplateProcedimento.anexo,
      "localUso": "LICENCIAMENTO_AMBIENTAL",
      "maxFiles": 1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered w-100 gap-10"
  }, [_c('div', {
    staticClass: "w-20"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.licencaTemplateProcedimento.validade),
      callback: function($$v) {
        _vm.$set(_vm.licencaTemplateProcedimento, "validade", $$v)
      },
      expression: "licencaTemplateProcedimento.validade"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-80"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplateProcedimento.observacoes),
      expression: "licencaTemplateProcedimento.observacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Justificativa da seleção"
    },
    domProps: {
      "value": (_vm.licencaTemplateProcedimento.observacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.licencaTemplateProcedimento, "observacoes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.editarLicencaProcedimentos && !_vm.editandoLinhaProcedimento) ? _c('div', {
    staticClass: "row-flex centered-end w-100 sessao-salvar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleProcedimento(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.adicionarProcedimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Adicionar ")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaProcedimentos && _vm.editandoLinhaProcedimento) ? _c('div', {
    staticClass: "row-flex centered-end w-100 sessao-salvar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleProcedimento(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarEdicaoProcedimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Salvar Edição ")])], 1) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('legend', {
    staticStyle: {
      "background-color": "#fcfcfc"
    }
  }, [_vm._v("\n         Licenças (no decorrer ou no final do projeto)\n   ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('label', {
    staticClass: "control-label f-required label-head"
  }, [_vm._v("3 - Quais Licenças Ambientais devem ser apresentadas no decorrer ou ao final da execução do projeto?")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('div', {
    staticClass: "column all-centered w-100 gap-10"
  }, [(!_vm.editarLicencaAmbiental) ? _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleLicencaAmbiental(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n           Adicionar Licença \n         ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editarLicencaAmbiental) ? _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.tableLicencaAmbiental.bordered,
      "items": _vm.tableLicencaAmbiental.items,
      "hover": _vm.tableLicencaAmbiental.hover,
      "fields": _vm.tableLicencaAmbiental.fields,
      "filter": _vm.tableLicencaAmbiental.filter,
      "current-page": _vm.tableLicencaAmbiental.currentPage,
      "per-page": _vm.tableLicencaAmbiental.perPage,
      "sort-by": _vm.tableLicencaAmbiental.sortBy,
      "sort-desc": _vm.tableLicencaAmbiental.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableLicencaAmbiental, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableLicencaAmbiental, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableLicencaAmbiental, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableLicencaAmbiental, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "edita-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              return _vm.editaLicencaAmbiental(row.item, row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "exclui-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.confirmaExclusao('Confirma Exclusão?', function () { return _vm.excluirLicencaAmbiental(row.item); })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    }, {
      key: "prazo_apresentacao",
      fn: function(row) {
        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
          staticClass: "badge badge-danger",
          attrs: {
            "title": "Vencida"
          }
        }, [_vm._v("\n                 Prazo vencido em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : (row.value) ? _c('span', {
          staticClass: "badge badge-success",
          attrs: {
            "title": "Dentro da validade"
          }
        }, [_vm._v("\n               " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")]) : _vm._e()]
      }
    }, {
      key: "prazo_renovacao",
      fn: function(row) {
        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
          staticClass: "badge badge-danger",
          attrs: {
            "title": "Vencida"
          }
        }, [_vm._v("\n                 Prazo renovação vencido em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : (row.value) ? _c('span', {
          staticClass: "badge badge-success",
          attrs: {
            "title": "Dentro da validade"
          }
        }, [_vm._v("\n               " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")]) : _vm._e()]
      }
    }, {
      key: "anexo",
      fn: function(row) {
        return [_c('a', {
          staticClass: "ng-binding",
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onDownload(row.value[0])
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.value[0].ds_nome_arquivo))])]
      }
    }], null, false, 4058477465)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaAmbiental) ? _c('div', {
    staticClass: "column start-centered edicao-container"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cadastro de Licença ")]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("2 - Selecione a Licença: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaAmbientalTemplate.licenca),
      expression: "licencaAmbientalTemplate.licenca"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tipo de Ação",
      "placeholder": "Selecione",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.licencaAmbientalTemplate, "licenca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposAmbientais), function(tipo) {
    return _c('option', {
      domProps: {
        "value": tipo.licenca
      }
    }, [_vm._v(_vm._s(tipo.licenca))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered w-100 gap-10"
  }, [_c('div', {
    staticClass: "w-20"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.licencaAmbientalTemplate.prazo_apresentacao),
      callback: function($$v) {
        _vm.$set(_vm.licencaAmbientalTemplate, "prazo_apresentacao", $$v)
      },
      expression: "licencaAmbientalTemplate.prazo_apresentacao"
    }
  })], 1), _vm._v(" "), (_vm.licencaAmbientalTemplate.licenca === 'Licença de Operação (LO)') ? _c('div', {
    staticClass: "w-20"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Prazo de Renovação:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.licencaAmbientalTemplate.prazo_renovacao),
      callback: function($$v) {
        _vm.$set(_vm.licencaAmbientalTemplate, "prazo_renovacao", $$v)
      },
      expression: "licencaAmbientalTemplate.prazo_renovacao"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column start-centered w-80"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Período de apresentação:")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaAmbientalTemplate.periodo_apresentacao),
      expression: "licencaAmbientalTemplate.periodo_apresentacao"
    }],
    attrs: {
      "type": "radio",
      "value": "Ao decorrer do projeto"
    },
    domProps: {
      "checked": _vm._q(_vm.licencaAmbientalTemplate.periodo_apresentacao, "Ao decorrer do projeto")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.licencaAmbientalTemplate, "periodo_apresentacao", "Ao decorrer do projeto")
      }
    }
  }), _vm._v(" No decorrer do projeto\n                 "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaAmbientalTemplate.periodo_apresentacao),
      expression: "licencaAmbientalTemplate.periodo_apresentacao"
    }],
    attrs: {
      "type": "radio",
      "value": "Ao final do projeto"
    },
    domProps: {
      "checked": _vm._q(_vm.licencaAmbientalTemplate.periodo_apresentacao, "Ao final do projeto")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.licencaAmbientalTemplate, "periodo_apresentacao", "Ao final do projeto")
      }
    }
  }), _vm._v(" No final do projeto\n                 "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]), _vm._v(" "), (_vm.editarLicencaAmbiental && !_vm.editandoLinhaLicencaAmbiental) ? _c('div', {
    staticClass: "row-flex centered-end w-100 sessao-salvar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleLicencaAmbiental(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.adicionarLicencaAmbiental()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Adicionar ")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaAmbiental && _vm.editandoLinhaLicencaAmbiental) ? _c('div', {
    staticClass: "row-flex centered-end w-100 sessao-salvar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleLicencaAmbiental(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarEdicaoLicencaAmbiental()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Salvar Edição ")])], 1) : _vm._e(), _vm._v(" "), _vm._m(0)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('legend', {
    staticStyle: {
      "background-color": "#fcfcfc"
    }
  }, [_vm._v("\n         Outros documentos obrigatórios\n   ")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('label', {
    staticClass: "control-label label-head"
  }, [_vm._v("4 - Outros licenciamentos ou autorizações ou certificações a serem apresentados no decorrer ou ao final da execução do projeto:")]) : _vm._e(), _vm._v(" "), (_vm.mostrarDemaisLicencas) ? _c('div', {
    staticClass: "column all-centered w-100 gap-10"
  }, [(!_vm.editarLicencaOutras) ? _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleLicencaOutras(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n           Adicionar Licença ou Autorização\n         ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editarLicencaOutras) ? _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.tableLicencaOutra.bordered,
      "items": _vm.tableLicencaOutra.items,
      "hover": _vm.tableLicencaOutra.hover,
      "fields": _vm.tableLicencaOutra.fields,
      "filter": _vm.tableLicencaOutra.filter,
      "current-page": _vm.tableLicencaOutra.currentPage,
      "per-page": _vm.tableLicencaOutra.perPage,
      "sort-by": _vm.tableLicencaOutra.sortBy,
      "sort-desc": _vm.tableLicencaOutra.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableLicencaOutra, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableLicencaOutra, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableLicencaOutra, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableLicencaOutra, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "edita-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              return _vm.editaLicencaOutras(row.item, row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "exclui-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.confirmaExclusao('Confirma Exclusão?', function () { return _vm.excluirLicencaOutro(row.item); })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    }, {
      key: "prazo_apresentacao",
      fn: function(row) {
        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
          staticClass: "badge badge-danger",
          attrs: {
            "title": "Vencida"
          }
        }, [_vm._v("\n                 Prazo vencido em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : (row.value) ? _c('span', {
          staticClass: "badge badge-success",
          attrs: {
            "title": "Dentro da validade"
          }
        }, [_vm._v("\n                 " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n               ")]) : _vm._e()]
      }
    }, {
      key: "anexo",
      fn: function(row) {
        return [_c('a', {
          staticClass: "ng-binding",
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onDownload(row.value[0])
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.value[0].ds_nome_arquivo))])]
      }
    }], null, false, 3995632641)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaOutras) ? _c('div', {
    staticClass: "column start-centered edicao-container"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cadastro de outros documentos obrigatórios ou autorizações ")]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("2 - Selecione a Licença ou Autorização: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaOutrasTemplate.licenca),
      expression: "licencaOutrasTemplate.licenca"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tipo de Ação",
      "placeholder": "Selecione",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.licencaOutrasTemplate, "licenca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposOutras), function(tipo) {
    return _c('option', {
      domProps: {
        "value": tipo.licenca
      }
    }, [_vm._v(_vm._s(tipo.licenca))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered w-100 gap-10"
  }, [_c('div', {
    staticClass: "w-20"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Data de Apresentação do documento:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.licencaOutrasTemplate.prazo_apresentacao),
      callback: function($$v) {
        _vm.$set(_vm.licencaOutrasTemplate, "prazo_apresentacao", $$v)
      },
      expression: "licencaOutrasTemplate.prazo_apresentacao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column start-centered w-80"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Período de apresentação:")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaOutrasTemplate.periodo_apresentacao),
      expression: "licencaOutrasTemplate.periodo_apresentacao"
    }],
    attrs: {
      "type": "radio",
      "value": "Ao decorrer do projeto"
    },
    domProps: {
      "checked": _vm._q(_vm.licencaOutrasTemplate.periodo_apresentacao, "Ao decorrer do projeto")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.licencaOutrasTemplate, "periodo_apresentacao", "Ao decorrer do projeto")
      }
    }
  }), _vm._v(" No decorrer do projeto\n                 "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaOutrasTemplate.periodo_apresentacao),
      expression: "licencaOutrasTemplate.periodo_apresentacao"
    }],
    attrs: {
      "type": "radio",
      "value": "Ao final do projeto"
    },
    domProps: {
      "checked": _vm._q(_vm.licencaOutrasTemplate.periodo_apresentacao, "Ao final do projeto")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.licencaOutrasTemplate, "periodo_apresentacao", "Ao final do projeto")
      }
    }
  }), _vm._v(" No final do projeto\n                 "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaOutrasTemplate.observacoes),
      expression: "licencaOutrasTemplate.observacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Justificativa da seleção"
    },
    domProps: {
      "value": (_vm.licencaOutrasTemplate.observacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.licencaOutrasTemplate, "observacoes", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.editarLicencaOutras && !_vm.editandoLinhaLicencaOutras) ? _c('div', {
    staticClass: "row-flex centered-end w-100 sessao-salvar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleLicencaOutras(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.adicionarLicencaOutra()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Adicionar ")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaOutras && _vm.editandoLinhaLicencaOutras) ? _c('div', {
    staticClass: "row-flex centered-end w-100 sessao-salvar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleLicencaOutras(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarEdicaoLicencaOutros()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Salvar Edição ")])], 1) : _vm._e(), _vm._v(" "), _vm._m(1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.cadastroProposta && _vm.telaProjeto) ? _c('legend', {
    staticStyle: {
      "background-color": "#fcfcfc"
    }
  }, [_vm._v("\n     Estoque\n   ")]) : _vm._e(), _vm._v(" "), (!_vm.cadastroProposta && _vm.telaProjeto) ? _c('label', {
    staticClass: "control-label label-head"
  }, [_vm._v("5 - Estoque Passivo GEIMP:")]) : _vm._e(), _vm._v(" "), (_vm.telaProjeto) ? _c('div', {
    staticClass: "column all-centered w-100 gap-10"
  }, [(!_vm.editarLicencaEstoque && !_vm.cadastroProposta) ? _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEstoque(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n           Adicionar Licença Estoque \n         ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editarLicencaEstoque && !_vm.cadastroProposta) ? _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.tableEstoque.bordered,
      "items": _vm.tableEstoque.items,
      "hover": _vm.tableEstoque.hover,
      "fields": _vm.tableEstoque.fields,
      "filter": _vm.tableEstoque.filter,
      "current-page": _vm.tableEstoque.currentPage,
      "per-page": _vm.tableEstoque.perPage,
      "sort-by": _vm.tableEstoque.sortBy,
      "sort-desc": _vm.tableEstoque.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableEstoque, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableEstoque, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableEstoque, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableEstoque, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "edita-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              return _vm.editaEstoque(row.item, row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "exclui-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.confirmaExclusao('Confirma Exclusão?', function () { return _vm.excluiEstoque(row.item); })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    }, {
      key: "validade",
      fn: function(row) {
        return [(row.value && _vm.moment.utc(row.value).endOf('day').isBefore(_vm.moment.utc())) ? _c('span', {
          staticClass: "badge badge-danger",
          attrs: {
            "title": "Vencida"
          }
        }, [_vm._v("\n               Vencida em " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")]) : (row.value) ? _c('span', {
          staticClass: "badge badge-success",
          attrs: {
            "title": "Dentro da validade"
          }
        }, [_vm._v("\n               " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")]) : _vm._e()]
      }
    }, {
      key: "anexo",
      fn: function(row) {
        return [_c('a', {
          staticClass: "ng-binding",
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onDownload(row.value)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.value.ds_nome_arquivo))])]
      }
    }], null, false, 4176265519)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaEstoque) ? _c('div', {
    staticClass: "column start-centered edicao-container"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cadastro de procedimento ")]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Selecione o Documento: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplateEstoque.licenca),
      expression: "licencaTemplateEstoque.licenca"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tipo de Ação",
      "placeholder": "Selecione",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.licencaTemplateEstoque, "licenca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposLicencaTodos), function(tipo) {
    return _c('option', {
      domProps: {
        "value": tipo.licenca
      }
    }, [_vm._v(_vm._s(tipo.licenca))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered w-100"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Anexo:")]), _vm._v(" "), _c('uploadLicencas', {
    staticClass: "w-100",
    attrs: {
      "propDocumentos": _vm.licencaTemplateEstoque.anexo,
      "localUso": "LICENCIAMENTO_AMBIENTAL",
      "maxFiles": 1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered w-100 gap-10"
  }, [_c('div', {
    staticClass: "w-20"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.licencaTemplateEstoque.validade),
      callback: function($$v) {
        _vm.$set(_vm.licencaTemplateEstoque, "validade", $$v)
      },
      expression: "licencaTemplateEstoque.validade"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-80"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Observação:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licencaTemplateEstoque.observacoes),
      expression: "licencaTemplateEstoque.observacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Justificativa da seleção"
    },
    domProps: {
      "value": (_vm.licencaTemplateEstoque.observacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.licencaTemplateEstoque, "observacoes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.editarLicencaEstoque && !_vm.editandoLinhaEstoque) ? _c('div', {
    staticClass: "row-flex centered-end w-100 sessao-salvar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEstoque(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.adicionarEstoque()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Adicionar ")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarLicencaEstoque && _vm.editandoLinhaEstoque) ? _c('div', {
    staticClass: "row-flex centered-end w-100 sessao-salvar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEstoque(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Cancelar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarEdicaoEstoque()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n             Salvar Edição ")])], 1) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row end-centered"
  }, [_c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarLicencas()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n       Salvar Licenças ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label label-head label-aviso"
  }, [_c('b', [_vm._v("Atenção")]), _vm._v(": o prazo de execução/vigência precisa abranger este período previsto para não haver futuros aditivos de prorrogação.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label label-head label-aviso"
  }, [_c('b', [_vm._v("Atenção")]), _vm._v(": o prazo de execução/vigência precisa abranger este período previsto para não haver futuros aditivos de prorrogação.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aefbfbd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/licenciamentoAmbiental/cadastroLicencas.vue
// module id = 2059
// module chunks = 1